import React from 'react'
import { Grid as BaseGrid, Hidden as BaseHidden, styled } from '@mui/material'
import { InputPrefix, Button as BaseButton } from '@chilecompra/react-kit/components'

export const DesktopNavigation = styled('div')`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 30px;
  margin: 71px 0;
  width: 100%;

  ${props => props.theme.breakpoints.between('sm', 'lg')} {
    display: flex;
    justify-content: space-between;
    margin: 40px 0 0;
  }
`

export const Hidden = styled(BaseHidden)``

export const Image = styled('img')`
  width: 100%;
`

export const Instructions = styled('section')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-top: 34px;

  ${props => props.theme.breakpoints.between('xs', 'lg')} {
    margin-top: 15px;
    text-align: left;
  }
`

export const MobileButtons = styled(BaseButton)`
  flex-grow: 1;
  width: 100%;
`

export const MobileNavigation = styled('div')`
  align-items: stretch;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: 30px;
  width: 100%;

  ${props => props.theme.breakpoints.up('sm')} {
    width: 50%;
  }
  ${props => props.theme.breakpoints.between('md', 'lg')} {
    margin-top: 0;
    width: 60%;
  }
`

export const PhoneNumberPrefix = styled(InputPrefix)`
  padding: 0.375rem 0.75rem;
`

export const Root = styled('div')`
  margin: 0;
  width: 100%;
`

export const Section = styled(({ margin, maxWidth, padding, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin || 'initial'};
  max-width: ${props => props.maxWidth || 'initial'};
  padding: ${props => props.padding || '0'};
  text-align: left;

  ${props => props.theme.breakpoints.between('xs', 'lg')} {
    min-width: 100%;
  }

  label {
    color: ${props => props.theme.palette.brand.black1};
  }
`

export const Strong = styled('b')`
  font-weight: 700;
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;

  ${props => props.theme.breakpoints.down('sm')} {
    margin: 0;
    text-align: left;
    font-size: 22px;
    line-height: 26px;
  }
`

export const ToastContainer = styled('div')`
  & span {
    font-feature-settings:
      'liga' off,
      'clig' off;
    font-family: ${props => props.theme.typography.fontFamily};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: ${props => props.theme.palette.brand.black1};
  }
`
